import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import validateFormEn from "../../Helpers/validateFormEn";
import validateFormEs from "../../Helpers/validateFormEs";
import axios from "axios";
import { getAllDogs } from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import perrodef from "../../imgs/perrodef.png";

const Form = ({ updateDog }) => {
  // HOOKS
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allTemps = useSelector((state) => state.temps);
  const lenguage = useSelector((state) => state.lenguage);
  // STATES
  const [errors, setErrors] = useState({});
  const [loadingImg, setLoadingImg] = useState(false);
  const [image, setImage] = useState(null);
  const [temps, setTemps] = useState([]);
  const [newRace, setNewRace] = useState({
    name: "",
    heightMin: null,
    heightMax: null,
    weightMin: null,
    weightMax: null,
    lifeSpanMin: null,
    lifeSpanMax: null,
    image: null,
  });
  // HANDLERS
  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewRace({ ...newRace, [name]: value });
  };

  const handleChangeTemp = (event) => {
    // setTemps({ ...temps, text: event.target.value });
    const targ = event.target.value;
    if (temps.find((temp) => temp.id === Number(targ))) return;
    const tem = allTemps.find((temp) => temp.id === Number(targ));
    setTemps([...temps, tem]);
  };
  const handleDeleteTemp = (event) => {
    const targ = event.target.value;
    setTemps([...temps.filter((temp) => temp.id !== Number(targ))]);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    if (!updateDog) {
      axios
        .post("/dogs", {
          name: newRace.name,
          image: newRace.image
            ? newRace.image
            : "https://imagesvc.meredithcorp.io/v3/mm/image?url=https%3A%2F%2Fstatic.onecms.io%2Fwp-content%2Fuploads%2Fsites%2F47%2F2021%2F03%2F12%2Fpomeranian-white-puppy-921029690-2000.jpg",
          life_span: `${newRace.lifeSpanMin} - ${newRace.lifeSpanMax}`,
          height: `${newRace.heightMin} - ${newRace.heightMax}`,
          weight: `${newRace.weightMin} - ${newRace.weightMax}`,
          temps: temps,
        })
        .then((res) => {
          dispatch(getAllDogs());
          window.alert(
            lenguage ? "Breed successfully added" : "Raza agregado con éxito"
          );
          
          setTemps([]);
          navigate(`/dogdetail/${res.data.id}`);
        })
        .catch((error) => {
          lenguage
            ? window.alert(`Error adding new breed: ${error.message}`)
            : window.alert(`Error al agregar raza: ${error.message}`);
        });
    } else {
      axios
        .put(`/dogs/${updateDog.id}`, {
          name: newRace.name,
          image: newRace.image,
          life_span: `${newRace.lifeSpanMin} - ${newRace.lifeSpanMax}`,
          height: `${newRace.heightMin} - ${newRace.heightMax}`,
          weight: `${newRace.weightMin} - ${newRace.weightMax}`,
          temps: temps,
        })
        .then(() => {
          dispatch(getAllDogs());
          lenguage
            ? window.alert("Successfully modified breed")
            : window.alert("Raza modificada con éxito");
          setNewRace({
            name: "",
            heightMin: 0,
            heightMax: 0,
            weightMin: 0,
            weightMax: 0,
            lifeSpanMin: 0,
            lifeSpanMax: 0,
          });
          setTemps([]);
          navigate(-1);
        })
        .catch((error) =>
          lenguage
            ? window.alert(`Error modifying breed: ${error.message}`)
            : window.alert(`Error al modificar raza: ${error.message}`)
        );
    }
  };
  const handlerImage = (event) => {
    // setImage(event.target.files[0]);
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e)=>{
      setImage(e.target.result)
    }
    reader.readAsDataURL(file)
  };
  const handleSendImage = async () => {
    if (!image)
      return alert(
        lenguage ? "You must select an image" : "Debes seleccionar una imagen"
      );
    // const formData = new FormData();
    // formData.append("image", image);
    setLoadingImg(true);
    axios
      .post("/images", {image})
      .then(({data}) => {
        alert(data.msg);
        setNewRace({ ...newRace, image: data.url });
      })
      .catch((err) => {
        alert(err.response.data.msg);
      })
      .finally(() => {
        setImage(null);
        setLoadingImg(false);
      });
  };

  //NewRace ErrorHandler
  useEffect(() => {
    lenguage
      ? setErrors(validateFormEn(newRace, temps))
      : setErrors(validateFormEs(newRace, temps));
  }, [newRace, temps, lenguage]);

  //Update Dog
  useEffect(() => {
    if (updateDog) {
      setNewRace({
        name: updateDog.name,
        heightMin: updateDog.height.metric.split(" - ")[0],
        heightMax: updateDog.height.metric.split(" - ")[1],
        weightMin: updateDog.weight.metric.split(" - ")[0],
        weightMax: updateDog.weight.metric.split(" - ")[1],
        lifeSpanMin: updateDog.life_span.split(" - ")[0],
        lifeSpanMax: updateDog.life_span.split(" - ")[1],
        image: updateDog.image.url,
      });
      setTemps(updateDog.Temperaments);
    }
  }, [updateDog]); //eslint-disable-line

  return (
    <>
      <div className="form_container">
        <form onSubmit={handleSubmit}>
          <div className="inputs_container">
            <section className="name-form">
              <h3 className={errors.name ? "title-input" : ""}>
                {lenguage ? "Name" : "Nombre"}
              </h3>
              <div className="input-form">
                <input
                  onChange={handleChange}
                  type="text"
                  name="name"
                  value={newRace.name}
                  placeholder={lenguage ? "Name breed" : "Nombre de la raza"}
                />
                <label
                  htmlFor="name"
                  style={newRace.name ? { display: "block" } : {}}
                >
                  {lenguage ? "Name breed" : "Nombre de la raza"}
                </label>
              </div>
            </section>

            <section className="sec-height">
              <h3 className={errors.height ? "title-input" : ""}>
                {lenguage ? "Height" : "Altura"}
              </h3>
              <div className="input-form one">
                <input
                  onChange={handleChange}
                  type="number"
                  name="heightMin"
                  value={newRace.heightMin}
                  placeholder="Min"
                />
                <label
                  htmlFor="heightMin"
                  style={newRace.heightMin ? { display: "block" } : {}}
                >
                  Min
                </label>
              </div>
              <div className="input-form two">
                <input
                  onChange={handleChange}
                  type="number"
                  name="heightMax"
                  value={newRace.heightMax}
                  placeholder="Max"
                />
                <label
                  htmlFor="heightMax"
                  style={newRace.heightMax ? { display: "block" } : {}}
                >
                  Max
                </label>
              </div>
            </section>

            <section className="sec-weight">
              <h3 className={errors.weight ? "title-input" : ""}>
                {lenguage ? "Weight" : "Peso"}
              </h3>
              <div className="input-form one">
                <input
                  onChange={handleChange}
                  type="number"
                  name="weightMin"
                  value={newRace.weightMin}
                  placeholder="Min"
                />
                <label
                  htmlFor="weightMin"
                  style={newRace.weightMin ? { display: "block" } : {}}
                >
                  Min
                </label>
              </div>
              <div className="input-form two">
                <input
                  onChange={handleChange}
                  type="number"
                  name="weightMax"
                  value={newRace.weightMax}
                  placeholder="Max"
                />
                <label
                  htmlFor="weightMax"
                  style={newRace.weightMax ? { display: "block" } : {}}
                >
                  Max
                </label>
              </div>
            </section>

            <section
              className={lenguage ? "sec-lifeSpan-en" : "sec-lifeSpan-es"}
            >
              <h3 className={errors.lifeSpan ? "title-input" : ""}>
                {lenguage ? "Life span" : "Esperanza de vida"}
              </h3>
              <div className="input-form one">
                <input
                  onChange={handleChange}
                  type="number"
                  name="lifeSpanMin"
                  value={newRace.lifeSpanMin}
                  placeholder="Min"
                />
                <label
                  htmlFor="lifeSpanMin"
                  style={newRace.lifeSpanMin ? { display: "block" } : {}}
                >
                  Min
                </label>
              </div>
              <div className="input-form two">
                <input
                  onChange={handleChange}
                  type="number"
                  name="lifeSpanMax"
                  value={newRace.lifeSpanMax}
                  placeholder="Max"
                />
                <label
                  htmlFor="lifeSpanMax"
                  style={newRace.lifeSpanMax ? { display: "block" } : {}}
                >
                  Max
                </label>
              </div>
            </section>

            <section className="sec-temps">
              <h3 className={errors.temps ? "title-input" : ""}>
                {lenguage ? "Temperament/s" : "Temperamento/s"}
              </h3>
              <select
                name="tempraments"
                onChange={handleChangeTemp}
                className="form-select"
              >
                {allTemps?.map((temp, i) => (
                  <option key={i + "B"} value={temp.id}>
                    {temp.name}
                  </option>
                ))}
              </select>
              <ul className="form-tempList">
                {temps.length
                  ? temps.map((temp, index) => (
                      <>
                        <li key={temp.id + "A"}>
                          <div>
                            <span>{temp.name}</span>
                            <button
                              key={temp.id + "AA"}
                              type="reset"
                              onClick={handleDeleteTemp}
                              value={temp.id}
                            >
                              x
                            </button>
                          </div>
                        </li>
                      </>
                    ))
                  : null}
              </ul>
              {/* <button onClick={handleSubmitTemp}>Añadir temperamento</button> */}
            </section>
          </div>
          <section className="sec-left">
            <section className="errors-form">
              {errors.name ? (
                <p className="errors">{errors.name}</p>
              ) : (
                <p className="success">
                  {lenguage ? "Valid name" : "Nombre valido"}
                </p>
              )}

              {errors.height ? (
                <p className="errors">{errors.height}</p>
              ) : (
                <p className="success">
                  {lenguage ? "Valid height" : "Altura valida"}
                </p>
              )}
              {errors.weight ? (
                <p className="errors">{errors.weight}</p>
              ) : (
                <p className="success">
                  {lenguage ? "Valid weight" : "Peso valido"}
                </p>
              )}
              {errors.lifeSpan ? (
                <p className="errors">{errors.lifeSpan}</p>
              ) : (
                <p className="success">
                  {lenguage ? "Valid life span" : "Esperanza de vida valida"}
                </p>
              )}
              {errors.temps ? (
                <p className="errors">{errors.temps}</p>
              ) : (
                <p className="success">
                  {lenguage ? "Valid temperament" : "Temperamento valido"}
                </p>
              )}
            </section>
            <section className="sec-image-form">
              {!loadingImg &&
                (newRace.image ? (
                  <img src={newRace.image} alt="imagenDog" />
                ) : (
                  <img src={perrodef} alt="imagenDefautl" />
                ))}
              {loadingImg && (
                <img
                  src="https://usagif.com/wp-content/uploads/loading-13.gif"
                  alt="loading"
                  className="gif-loading"
                />
              )}
              <div className="div-img">
                <input
                  type="file"
                  name="image"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={handlerImage}
                  className={lenguage ? "input-image-en" : "input-image-es"}
                />
                <button
                  type="reset"
                  onClick={handleSendImage}
                  className="btn-image-form"
                >
                  {lenguage ? "Change image" : "Cambiar imagen"}
                </button>
              </div>
            </section>
          </section>
          {!updateDog &&
            (!Object.keys(errors).length ? (
              <button type="submit" name="create" className="btn-form create">
                {lenguage ? "Create breed" : "Crear Raza"}{" "}
              </button>
            ) : (
              <button disabled="disabled" className="btn-form create">
                {lenguage ? "Create breed" : "Crear Raza"}
              </button>
            ))}
          {updateDog &&
            (!Object.keys(errors).length ? (
              <button type="submit" name="modify" className="btn-form modify">
                {lenguage ? "Modify breed" : "Modificar Raza"}
              </button>
            ) : (
              <button disabled="disabled" className="btn-form modify">
                {lenguage ? "Modify breed" : "Modificar Raza"}
              </button>
            ))}
        </form>
      </div>
    </>
  );
};

export default Form;
